import React, { AnchorHTMLAttributes, FC } from 'react';
import { Product } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  product: Product;
  children?: React.ReactNode;
};

const ProductLink: FC<Props> = ({ product, children, ...props }) => {
  const { buildUrl } = useUrlGenerator();

  return (
    <a href={buildUrl(product.href)} {...props}>
      {children}
    </a>
  );
};

export default ProductLink;
